import { render, staticRenderFns } from "./ChangeSetupFee.vue?vue&type=template&id=50e70a06&"
import script from "./ChangeSetupFee.vue?vue&type=script&lang=js&"
export * from "./ChangeSetupFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports